
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaUsuariosByClienteId } from 'src/redux/slices/user';

// components
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';
import { setContato } from 'src/redux/slices/global';
import ModalVerContato from 'src/sections/@dashboard/cadastro/ModalVerContato';
import getActionCriarChatAndNovaMensagem from 'src/actions/chats/getActionCriarChatAndNovaMensagem';
import { validarNumeroWhatsapp } from 'src/utils/functions';
import getActionChatInfo from 'src/actions/chats/getActionChatInfo';
import { PATH_CHAT } from 'src/routes/paths';
import v2_actionListaContatosCliente from 'src/actions/v2/contatos/v2_actionListaContatosCliente';
import v2_actionPesquisarContatos from 'src/actions/v2/contatos/v2_actionPesquisarContatos';
import { getChatInfoByChatId, getMensagensWhatsapp, getMensagensWhatsappDb, setChatInfo } from 'src/redux/slices/chat';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import ModalUploadContatos from 'src/sections/@dashboard/cadastro/ModalUploadContatos';
import Iconify from 'src/components/Iconify';
import ModalGerenciarListas from 'src/sections/@dashboard/cadastro/ModalGerenciarListas';

//zui
import { Button } from 'src/@/components/ui/button';
import v2_actionExportarContatos from 'src/actions/v2/contatos/v2_actionExportarContatos';
import v2_actionVerificarNumero from 'src/actions/v2/cliente/v2_actionVerificarNumero';
// ----------------------------------------------------------------------

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog";

import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"

import { Input } from 'src/@/components/ui/input';
import { Tooltip } from '@mui/material';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarContato from 'src/actions/v2/contatos/v2_actionDeletarContato';
import v2_actionVincularContatosLista from 'src/actions/v2/contatos/v2_actionVincularContatosLista';
import v2_actionListarListas from 'src/actions/v2/contatos/v2_actionListarListas';
import { formataNumeroCelular } from 'src/utils/functions';
import { fDateTime } from 'src/utils/formatTime';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Card } from 'src/@/components/ui/card';
import PageContainerHeader from 'src/components/PageContainerHeader';
import useResponsive from 'src/hooks/useResponsive';

const TABLE_COLUMNS = [
    { key: 'nome', label: 'Nome', minW: '160px', sticky: true, stickyLeft: '36px' },
    { key: 'listas', label: 'Listas', minW: '140px', hiddenOnMobile: true },
    { key: 'telefone', label: 'Telefone', minW: '140px' },
    { key: 'email', label: 'Email', minW: '180px', hiddenOnMobile: true },
    { key: 'cpf', label: 'CPF', minW: '130px', hiddenOnMobile: true },
    { key: 'dataNascimento', label: 'Nascimento', minW: '120px', hiddenOnMobile: true },
    { key: 'cidade', label: 'Cidade', minW: '120px', hiddenOnMobile: true },
    { key: 'data_criacao', label: 'Criação', minW: '150px', hiddenOnMobile: true },
    { key: 'custom_fields', label: 'Campos', minW: '180px', hiddenOnMobile: true },
    { key: 'actions', label: 'Ações', minW: '120px' },
];

// ----------------------------------------------------------------------

function applyFilter(tableData, filterName) {
    if (!filterName) return tableData;

    return tableData.filter((item) => {
        const searchTerm = filterName.toLowerCase();
        return (
            item.nome?.toLowerCase().includes(searchTerm) ||
            item.telefone?.includes(searchTerm) ||
            item.info?.email?.toLowerCase().includes(searchTerm) ||
            item.info?.cpf?.includes(searchTerm) ||
            item.info?.endereco?.cidade?.toLowerCase().includes(searchTerm)
        );
    });
}

const ModalConfirmChannel = ({
    open,
    contato,
    user,
    cliente,
    onOpenChange,
    canais,
    onSubmit,
    enqueueSnackbar,
    onClose,
    navigate,
    dispatch
}) => {

    const [selected, setSelected] = useState(null);
    const [loadingNovoChat, setLoadingNovoChat] = useState(false);

    function buscarMessagesAndInfo(chat) {
        if (cliente.config.chat_source_db) {
            dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
        } else {
            dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente));
        }
        if (chat) {
            dispatch(setChatInfo(chat));
        } else {
            dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
        }
    }


    async function checkIsMyChat(id) {
        try {
            const response = await v2_actionBuscarChatById(id);
            if (response.status === 200) {
                if (response.data.direciona_usuarios.includes(user.id)) {
                    buscarMessagesAndInfo(response.data);
                    navigate(`${PATH_CHAT.chat.root}`);
                    return true;
                } else {
                    enqueueSnackbar('Chat já está cadastrado com outro agente', { variant: 'warning' });
                    return false;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    async function onCriarChat(row) {
        setLoadingNovoChat(true);


        try {
            let querys = `?is_contact=1&is_chat=1&is_whatsapp=1`;
            const checkNumber = await v2_actionVerificarNumero(selected?.cliente_id, validarNumeroWhatsapp(row.telefone), querys);

            if (checkNumber.status === 200) {
                if (checkNumber.data.data.isChatExist) {
                    checkIsMyChat(checkNumber.data.data.chatId);
                    setLoadingNovoChat(false);
                    return;
                } else if (!checkNumber.data.data.isWhatsapp) {
                    enqueueSnackbar('Erro ao criar chat. Número não existe no whatsapp', { variant: 'error' });
                    setLoadingNovoChat(false);
                    return;
                }
            }
            const response_chat_info = await getActionChatInfo(selected.cliente_id, validarNumeroWhatsapp(row.telefone));

            if (response_chat_info.data) {
                checkIsMyChat(checkNumber.data._id);
                setLoadingNovoChat(false);
            } else {

                try {
                    let data1 = {
                        nomeCliente: row.nome || '',
                        numeroCliente: validarNumeroWhatsapp(row.telefone),
                        statusRoom: "Atendendo",
                        usuarioId: user.id,
                        clienteId: selected.cliente_id
                    }
                    await getActionCriarChatAndNovaMensagem(data1)
                    await getActionChatInfo(selected.cliente_id, validarNumeroWhatsapp(row.telefone));
                    setLoadingNovoChat(false);
                    navigate(`${PATH_CHAT.chat.root}`);
                } catch (error) {
                    console.log(error)
                    setLoadingNovoChat(false)
                }

            }
        } catch (error) {
            console.log(error)
            setLoadingNovoChat(false)
        }

    }

    return (
        <Dialog open={open} onOpenChange={onClose}>

            <DialogContent className="sm:max-w-[425px] dark:bg-[#222529] dark:border-[#383838]">
                <DialogHeader>
                    <DialogTitle className="dark:text-[#D1D2D3]">Criar chat</DialogTitle>
                    <DialogDescription className="dark:text-[#ABABAD]">
                        Selecione o canal que deseja utilizar para criar o chat
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4 mt-3 w-full">
                    <Select onValueChange={value => {
                        setSelected(value)
                    }}
                        value={selected}
                    >
                        <SelectTrigger className="w-[180px] dark:bg-[#1A1D21] dark:border-[#383838] dark:text-[#D1D2D3]">
                            <SelectValue placeholder="Selecione o canal" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectGroup>
                                {canais && canais.map((item, index) => (
                                    <SelectItem key={item._id || index} value={item}>
                                        {item.nome}
                                    </SelectItem>
                                ))}
                            </SelectGroup>
                        </SelectContent>
                    </Select>
                </div>
                <DialogFooter>
                    <ButtonLoading onClick={() => onCriarChat(contato)} loading={loadingNovoChat}>Criar chat</ButtonLoading>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}



export default function Contatos() {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { user, cliente } = useAuth();
    const isMobile = useResponsive('down', 'md');
    const visibleColumns = isMobile ? TABLE_COLUMNS.filter(col => !col.hiddenOnMobile) : TABLE_COLUMNS;
    const [contatos, setContatos] = useState([]);
    const [loadingContatos, setLoadingContatos] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [openModalVerContato, setStateModalVerContato] = useState(false);
    const [pesquisa, setPesquisa] = useState('');
    const [filterName, setFilterName] = useState('');
    const [contatoData, setContatoData] = useState(null);
    const [loadingNovoChat, setLoadingNovoChat] = useState(false);
    const tableData = contatos
    const [listaClientesCanais, setListaClientesCanais] = useState([]);

    const [canais, setCanais] = useState([]);
    const [selectedCanal, setSelectedCanal] = useState(null);

    const [openModalCriarChat, setOpenModalCriarChat] = useState(false);
    const [contatoChat, setContatoChat] = useState(null);

    const filteredUsers = applyFilter(tableData, filterName);
    const [openModalUpload, setOpenModalUpload] = useState(false);

    const [modalConfimacao, setModalConfirmacao] = useState(false);
    const [contatoId, setContatoId] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openModalListas, setOpenModalListas] = useState(false);

    const [selectedContatos, setSelectedContatos] = useState([]);
    const [listas, setListas] = useState([]);
    const [openModalVincularLista, setOpenModalVincularLista] = useState(false);
    const [selectedListaId, setSelectedListaId] = useState(null);
    const [loadingVincular, setLoadingVincular] = useState(false);

    const currentPageRows = filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const allCurrentPageSelected = currentPageRows.length > 0 && currentPageRows.every(row => selectedContatos.includes(row._id));

    function toggleSelectContato(id) {
        setSelectedContatos(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    }

    function toggleSelectAll() {
        if (allCurrentPageSelected) {
            setSelectedContatos(prev => prev.filter(id => !currentPageRows.some(row => row._id === id)));
        } else {
            const newIds = currentPageRows.map(row => row._id).filter(id => !selectedContatos.includes(id));
            setSelectedContatos(prev => [...prev, ...newIds]);
        }
    }

    async function handleVincularLista() {
        if (!selectedListaId || selectedContatos.length === 0) return;
        try {
            setLoadingVincular(true);
            await v2_actionVincularContatosLista(selectedContatos, selectedListaId);
            enqueueSnackbar(`${selectedContatos.length} contato(s) vinculado(s) com sucesso`, { variant: 'success' });
            setSelectedContatos([]);
            setOpenModalVincularLista(false);
            setSelectedListaId(null);
            await refreshContatosList();
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Erro ao vincular contatos', { variant: 'error' });
        } finally {
            setLoadingVincular(false);
        }
    }

    function buscarMessagesAndInfo(chat) {
        if (cliente.config.chat_source_db) {
            dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
        } else {
            dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente));
        }
        if (chat) {
            dispatch(setChatInfo(chat));
        } else {
            dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
        }
    }

    async function checkIsMyChat(id) {
        try {
            const response = await v2_actionBuscarChatById(id);

            if (response.status === 200) {
                if (response.data.direciona_usuarios.includes(user.id)) {
                    buscarMessagesAndInfo(response.data);
                    navigate(`${PATH_CHAT.chat.root}`);
                    return true;
                } else {
                    enqueueSnackbar('Chat já está cadastrado com outro agente', { variant: 'warning' });
                    return false;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    async function handleCriarChat(row) {
        setLoadingNovoChat(true);
        setContatoChat(row)
        // verificar se é multisession
        if (cliente?.multiSession === 1) {
            setOpenModalCriarChat(true);
            setLoadingNovoChat(false)
            return;
        }

        let querys = `?is_contact=1&is_chat=1&is_whatsapp=1`;
        const checkNumber = await v2_actionVerificarNumero(cliente._id, validarNumeroWhatsapp(row?.telefone), querys);

        if (checkNumber.status === 200) {
            if (checkNumber.data.data.isChatExist) {
                checkIsMyChat(checkNumber.data.data.chatId);
                setLoadingNovoChat(false)
                return;
            } else if (!checkNumber.data.data.isWhatsapp) {
                enqueueSnackbar('Erro ao criar chat. Número não existe no whatsapp', { variant: 'error' });
                setLoadingNovoChat(false)
                return;
            }
        }

        try {
            const response_chat_info = await getActionChatInfo(cliente._id, validarNumeroWhatsapp(row.telefone));
            if (response_chat_info.data) {
                buscarMessagesAndInfo(response_chat_info.data.data);
                setLoadingNovoChat(false);
            } else {

                try {
                    let data1 = {
                        nomeCliente: row.nome || '',
                        numeroCliente: validarNumeroWhatsapp(row.telefone),
                        statusRoom: "Atendendo",
                        usuarioId: user.id,
                        clienteId: cliente._id
                    }
                    await getActionCriarChatAndNovaMensagem(data1)
                    await getActionChatInfo(cliente._id, validarNumeroWhatsapp(row.telefone));
                    setLoadingNovoChat(false);
                    navigate(`${PATH_CHAT.chat.root}`);
                } catch (error) {
                    console.log(error)
                    setLoadingNovoChat(false)
                }

            }
        } catch (error) {
            enqueueSnackbar('Erro ao criar chat', { variant: 'error' });

            console.log(error)
            setLoadingNovoChat(false)
        }
    }


    async function buscarListaClientesCanais() {
        try {
            const response_clientes_canais = await actionListaClientesCanais(cliente._id)
            setListaClientesCanais(response_clientes_canais.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    async function handleDeleteContact() {
        try {
            setLoadingDelete(true);
            const response = await v2_actionDeletarContato(contatoId);
            if (response.status === 200) {
                enqueueSnackbar('Contato deletado com sucesso', { variant: 'success' });
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setContatoId(null);
                setLoadingDelete(false);
            }
        } catch (error) {
            console.log(error);
            setContatoId(null);
            setLoadingDelete(false);
            enqueueSnackbar('Erro ao deletar contato', { variant: 'error' });
        }
    }

    async function buscarCanais() {
        const response_clientes_canais = await actionListaClientesCanais(user.clienteId);
        setCanais(response_clientes_canais.data.data);
        setSelectedCanal(response_clientes_canais.data?.data[0]);
    }


    useEffect(() => {
        dispatch(getListaUsuariosByClienteId(user.clienteId));
        buscarCanais();
        buscarListaClientesCanais();
        v2_actionListarListas(cliente?._id).then(res => setListas(res.data?.data || [])).catch(console.log);

        async function carregarContatos() {
            if (cliente) {
                try {
                    setLoadingContatos(true);
                    const result = await v2_actionListaContatosCliente(cliente._id);
                    setContatos(result.data.data);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoadingContatos(false);
                }
            }
        }

        carregarContatos();
    }, []);

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    async function handlePesquisarContatos() {
        try {
            setLoadingContatos(true);
            if (pesquisa && pesquisa.trim() !== "") {
                const result = await v2_actionPesquisarContatos(cliente._id, pesquisa);
                setContatos(result.data.data);
                setFilterName(pesquisa);
            } else {
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setFilterName('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContatos(false);
        }
    }


    const handleExportarContatos = async () => {
        try {
            const response = await v2_actionExportarContatos(cliente._id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `lais-contatos-leads.xlsx`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error)
        }
    }
    async function refreshContatosList() {
        try {
            setLoadingContatos(true);
            if (pesquisa && pesquisa.trim() !== "") {
                const result = await v2_actionPesquisarContatos(cliente._id, pesquisa);
                setContatos(result.data.data);
                setFilterName(pesquisa);
            } else {
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setFilterName('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContatos(false);
        }
    }
    return (
        <div className="h-full flex flex-col overflow-hidden">
            <ModalConfimacao
                open={modalConfimacao}
                onClose={() => {
                    setModalConfirmacao(false);
                    setContatoId(null);
                }}
                onConfirm={async () => {
                    try {
                        await handleDeleteContact();
                        setModalConfirmacao(false);
                    } catch (error) {
                        console.log(error);
                        setModalConfirmacao(false);
                    }
                }}
                loadingFinalizar={loadingDelete}
                mensagem={'Deseja mesmo excluir esse contato?'}
            />
            {
                contatoData && (
                    <ModalVerContato
                        open={openModalVerContato}
                        onClose={() => setStateModalVerContato(false)}
                        contatoData={contatoData}
                        cliente={cliente}
                        user={user}
                        listaClientesCanais={[]}
                        loading={false}
                        callBackRefreshList={() => {
                            setStateModalVerContato(false);
                            refreshContatosList();
                        }}
                    />
                )
            }
            <ModalUploadContatos
                cliente={cliente}
                open={openModalUpload}
                onClose={() => setOpenModalUpload(false)}
                callBackRefreshList={refreshContatosList}
            />
            <ModalGerenciarListas
                open={openModalListas}
                onClose={() => setOpenModalListas(false)}
                clienteId={cliente?._id}
            />
            <ModalConfirmChannel
                open={openModalCriarChat}
                onClose={() => {
                    setOpenModalCriarChat(false);
                    setContatoChat(null);
                }}

                contato={contatoChat}
                cliente={cliente}
                user={user}
                onOpenChange={(value) => setOpenModalCriarChat(value)}
                canais={canais}
                enqueueSnackbar={enqueueSnackbar}
                navigate={navigate}
                dispatch={dispatch}
            />

            <Dialog open={openModalVincularLista} onOpenChange={() => { setOpenModalVincularLista(false); setSelectedListaId(null); }}>
                <DialogContent className="sm:max-w-[425px] dark:bg-[#222529] dark:border-[#383838]">
                    <DialogHeader>
                        <DialogTitle className="dark:text-[#D1D2D3]">Vincular a uma lista</DialogTitle>
                        <DialogDescription className="dark:text-[#ABABAD]">
                            Selecione a lista para vincular {selectedContatos.length} contato(s)
                        </DialogDescription>
                    </DialogHeader>
                    <div className="grid gap-4 py-4 mt-3 w-full">
                        <Select onValueChange={value => setSelectedListaId(value)} value={selectedListaId}>
                            <SelectTrigger className="w-full dark:bg-[#1A1D21] dark:border-[#383838] dark:text-[#D1D2D3]">
                                <SelectValue placeholder="Selecione a lista" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectGroup>
                                    {listas.map((lista) => (
                                        <SelectItem key={lista._id} value={lista._id}>
                                            {lista.nome}
                                        </SelectItem>
                                    ))}
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                    </div>
                    <DialogFooter>
                        <ButtonLoading onClick={handleVincularLista} loading={loadingVincular} disabled={!selectedListaId}>
                            Vincular
                        </ButtonLoading>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            {/* Floating selection bar */}
            {selectedContatos.length > 0 && (
                <div className="sticky z-50 mx-4 md:mx-0 mb-3 animate-in fade-in slide-in-from-bottom-2 duration-200">
                    <Card className="border-violet-200 dark:border-violet-500/30 bg-violet-50/90 dark:bg-violet-500/10 backdrop-blur-xl shadow-lg shadow-violet-500/10 px-5 py-3 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#7C3AED] text-white text-xs font-bold">
                                {selectedContatos.length}
                            </div>
                            <span className="text-sm font-medium text-violet-900 dark:text-violet-300">
                                contato(s) selecionado(s)
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Button
                                onClick={() => setOpenModalVincularLista(true)}
                                className="h-8 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-semibold rounded-lg transition-all"
                            >
                                <Iconify icon="fluent:list-20-regular" width={14} />
                                Vincular a lista
                            </Button>
                            <Button
                                variant="outline"
                                onClick={() => setSelectedContatos([])}
                                className="h-8 text-xs border-violet-200 dark:border-violet-500/30 text-violet-700 dark:text-violet-400 hover:bg-violet-100 dark:hover:bg-violet-500/20"
                            >
                                Limpar seleção
                            </Button>
                        </div>
                    </Card>
                </div>
            )}

            {/* Sticky Header Implementation */}
            <PageContainerHeader
                titleSection={
                    <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#7C3AED]/10 text-[#7C3AED]">
                            <Iconify icon="fluent:people-community-20-filled" width={24} />
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Contatos</h3>
                            <p className="text-[10px] text-gray-500 dark:text-[#ABABAD] font-medium">Gerencie sua lista de contatos</p>
                        </div>
                    </div>
                }
                middleSection={
                    <>
                        <div className="relative flex-1 max-w-sm">
                            <Iconify icon="fluent:search-12-filled" className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-[#ABABAD]" width={16} />
                            <Input
                                className="pl-9 h-9 bg-gray-50 dark:bg-[#1A1D21] border-gray-200 dark:border-[#383838] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 text-xs font-medium rounded-lg hover:border-[#7C3AED]/30 transition-all dark:text-[#D1D2D3] dark:placeholder-[#ABABAD]"
                                placeholder="Pesquisar por nome, telefone..."
                                value={pesquisa}
                                onChange={(e) => setPesquisa(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') handlePesquisarContatos();
                                }}
                            />
                        </div>
                        <Button className="h-9 px-3 text-xs text-gray-600 dark:text-[#ABABAD] hover:text-[#7C3AED] bg-slate-200 dark:bg-[#383838] hover:bg-violet-50 dark:hover:bg-violet-500/10 transition-colors" onClick={handlePesquisarContatos}>
                            Buscar
                        </Button>
                    </>
                }
                rightSection={
                    <div className="flex items-center gap-2">
                        <Tooltip title="Listas permitem agrupar contatos por categorias (ex: leads, clientes VIP, campanha X) para organizar e segmentar seus envios" placement="bottom">
                            <Button onClick={() => setOpenModalListas(true)} variant="outline" className="h-9 text-xs border-dashed border-gray-300 dark:border-[#383838] text-gray-600 dark:text-[#ABABAD] hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 gap-2">
                                <Iconify icon="fluent:list-20-regular" /> <span className="hidden sm:inline">Listas</span>
                            </Button>
                        </Tooltip>
                        <Button onClick={() => setOpenModalUpload(true)} variant="outline" className="h-9 text-xs border-dashed border-gray-300 dark:border-[#383838] text-gray-600 dark:text-[#ABABAD] hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 gap-2">
                            <Iconify icon="ic:outline-cloud-upload" /> <span className="hidden sm:inline">Importar</span>
                        </Button>
                        <Button onClick={handleExportarContatos} variant="outline" className="h-9 text-xs border-dashed border-gray-300 dark:border-[#383838] text-gray-600 dark:text-[#ABABAD] hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 gap-2">
                            <Iconify icon="file-icons:microsoft-excel" /> <span className="hidden sm:inline">Exportar</span>
                        </Button>
                        <Button onClick={() => dispatch(setContato({ loading: false, openModal: true }))} className="h-9 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white shadow-lg shadow-violet-500/20 text-xs font-semibold rounded-lg transition-all hover:scale-105 active:scale-95">
                            <Iconify icon="fluent:add-12-filled" /> Novo Contato
                        </Button>
                    </div>
                }
            />

            {/* Content Table Card */}
            <div className='w-[98%] mx-auto flex flex-col' style={{ height: 'calc(100vh - 120px)' }}>
                <Card className="flex-1 min-h-0 flex flex-col">

                    {/* Loading */}
                    {loadingContatos ? (
                        <div className="flex items-center justify-center py-20 flex-1">
                            <Iconify icon="mdi:loading" className="w-8 h-8 text-violet-500 animate-spin" />
                        </div>
                    ) : filteredUsers.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-20 text-gray-400 dark:text-[#ABABAD] flex-1">
                            <Iconify icon="mdi:account-off-outline" className="w-12 h-12 mb-3" />
                            <p className="text-sm font-medium">Nenhum contato encontrado</p>
                            <p className="text-xs mt-1">Tente outra pesquisa ou adicione um novo contato</p>
                        </div>
                    ) : (
                        <>
                            <div className="overflow-auto flex-1 min-h-0">
                                <table className={`w-full text-left border-collapse ${isMobile ? 'min-w-[400px]' : 'min-w-[1200px]'}`}>
                                    <thead>
                                        <tr className="bg-gray-50 dark:bg-[#1A1D21] border-b border-gray-200 dark:border-[#383838]">
                                            <th className="sticky left-0 z-10 bg-gray-50 dark:bg-[#1A1D21] px-2 py-1.5 border-r border-gray-200 dark:border-[#383838] min-w-[36px] w-[36px]">
                                                <Checkbox
                                                    checked={allCurrentPageSelected}
                                                    onCheckedChange={toggleSelectAll}
                                                    className="data-[state=checked]:bg-[#7C3AED] data-[state=checked]:border-[#7C3AED] h-3.5 w-3.5"
                                                />
                                            </th>
                                            {visibleColumns.map(col => (
                                                <th
                                                    key={col.key}
                                                    className={`px-3 py-1.5 border-r border-gray-100 dark:border-[#383838] text-[10px] font-bold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider ${col.sticky ? 'sticky z-10 bg-gray-50 dark:bg-[#1A1D21] border-r-gray-200' : ''}`}
                                                    style={{ minWidth: col.minW, ...(col.sticky ? { left: col.stickyLeft } : {}) }}
                                                >
                                                    {col.key === 'listas' ? (
                                                        <span className="inline-flex items-center gap-1">
                                                            {col.label}
                                                            <Tooltip title="Listas são grupos que organizam seus contatos por segmento, facilitando envios em massa e campanhas direcionadas" placement="top">
                                                                <span className="cursor-help text-gray-400 hover:text-violet-500 transition-colors">
                                                                    <Iconify icon="mdi:information-outline" width={13} />
                                                                </span>
                                                            </Tooltip>
                                                        </span>
                                                    ) : col.label}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIdx) => (
                                            <tr
                                                key={row._id || rowIdx}
                                                className={`border-b border-gray-100 dark:border-[#383838] cursor-pointer transition-colors hover:bg-violet-50/30 dark:hover:bg-violet-500/5 ${rowIdx % 2 === 0 ? 'bg-white dark:bg-[#222529]' : 'bg-gray-50/30 dark:bg-[#1A1D21]/30'}`}
                                                onClick={() => {
                                                    setContatoData(row);
                                                    setStateModalVerContato(true);
                                                }}
                                            >
                                                {/* Checkbox */}
                                                <td className="sticky left-0 z-10 px-2 py-1 border-r border-gray-200 dark:border-[#383838]" style={{ background: 'inherit' }} onClick={(e) => e.stopPropagation()}>
                                                    <Checkbox
                                                        checked={selectedContatos.includes(row._id)}
                                                        onCheckedChange={() => toggleSelectContato(row._id)}
                                                        className="data-[state=checked]:bg-[#7C3AED] data-[state=checked]:border-[#7C3AED] h-3.5 w-3.5"
                                                    />
                                                </td>

                                                {/* Nome */}
                                                <td className="sticky left-[36px] z-10 px-3 py-1 border-r border-gray-200 dark:border-[#383838]" style={{ background: 'inherit' }}>
                                                    <p className="text-[11px] font-medium text-gray-700 dark:text-[#D1D2D3] truncate leading-tight">{row.nome || '—'}</p>
                                                </td>

                                                {/* Listas */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838]">
                                                    <div className="flex flex-wrap gap-0.5">
                                                        {row.contact_lists_id && row.contact_lists_id.length > 0 ? (
                                                            row.contact_lists_id.map((lista, idx) => (
                                                                <span key={idx} className="bg-violet-100 dark:bg-violet-500/20 text-violet-700 dark:text-violet-400 px-1 py-px rounded text-[9px] font-medium whitespace-nowrap leading-tight">
                                                                    {lista.nome}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="text-gray-300 dark:text-[#565856] italic text-[11px]">—</span>
                                                        )}
                                                    </div>
                                                </td>}

                                                {/* Telefone */}
                                                <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-600 dark:text-[#D1D2D3] whitespace-nowrap leading-tight">
                                                    {formataNumeroCelular(row.telefone) || '—'}
                                                </td>

                                                {/* Email */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-600 dark:text-[#D1D2D3] max-w-[180px] leading-tight">
                                                    <span className="truncate block">{row.info?.email || <span className="text-gray-300 italic">—</span>}</span>
                                                </td>}

                                                {/* CPF */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-600 dark:text-[#D1D2D3] whitespace-nowrap font-mono leading-tight">
                                                    {row.info?.cpf || <span className="text-gray-300 italic font-sans">—</span>}
                                                </td>}

                                                {/* Data Nascimento */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-500 dark:text-[#ABABAD] whitespace-nowrap leading-tight">
                                                    {row.info?.dataNascimento || <span className="text-gray-300 italic">—</span>}
                                                </td>}

                                                {/* Cidade */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-600 dark:text-[#D1D2D3] leading-tight">
                                                    {row.info?.endereco?.cidade || <span className="text-gray-300 italic">—</span>}
                                                </td>}

                                                {/* Data Criação */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] text-[11px] text-gray-500 dark:text-[#ABABAD] whitespace-nowrap leading-tight">
                                                    {fDateTime(row.data_criacao) || '—'}
                                                </td>}

                                                {/* Campos Personalizados */}
                                                {!isMobile && <td className="px-3 py-1 border-r border-gray-100 dark:border-[#383838] max-w-[200px]">
                                                    {row.custom_fields && row.custom_fields.length > 0 ? (
                                                        <div className="flex flex-wrap gap-0.5">
                                                            {row.custom_fields.slice(0, 2).map((field, idx) => (
                                                                <span key={idx} className="text-[10px] truncate leading-tight">
                                                                    <span className="font-medium text-gray-500 dark:text-[#ABABAD]">{field.nome}:</span>
                                                                    <span className="ml-0.5 text-gray-700 dark:text-[#D1D2D3]">{field.valor}</span>
                                                                </span>
                                                            ))}
                                                            {row.custom_fields.length > 2 && (
                                                                <span className="text-[9px] text-violet-500 font-medium">+{row.custom_fields.length - 2}</span>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="text-gray-300 italic text-[11px]">—</span>
                                                    )}
                                                </td>}

                                                {/* Ações */}
                                                <td className="px-3 py-1" onClick={(e) => e.stopPropagation()}>
                                                    <div className="flex items-center gap-0.5">
                                                        <Tooltip title="Ver contato" placement="top">
                                                            <button
                                                                onClick={() => {
                                                                    setContatoData(row);
                                                                    setStateModalVerContato(true);
                                                                }}
                                                                className="w-6 h-6 flex items-center justify-center rounded hover:bg-gray-100 dark:hover:bg-[#383838] text-gray-400 hover:text-violet-600 transition-colors"
                                                            >
                                                                <Iconify icon="mdi:eye-outline" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title="Criar chat" placement="top">
                                                            <button
                                                                disabled={loadingNovoChat}
                                                                onClick={() => handleCriarChat(row)}
                                                                className="w-6 h-6 flex items-center justify-center rounded hover:bg-green-50 dark:hover:bg-green-500/10 text-gray-400 hover:text-green-600 transition-colors disabled:opacity-40"
                                                            >
                                                                <Iconify icon="ic:baseline-whatsapp" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title="Excluir" placement="top">
                                                            <button
                                                                onClick={() => {
                                                                    setContatoId(row._id);
                                                                    setModalConfirmacao(true);
                                                                }}
                                                                className="w-6 h-6 flex items-center justify-center rounded hover:bg-red-50 dark:hover:bg-red-500/10 text-gray-400 hover:text-red-500 transition-colors"
                                                            >
                                                                <Iconify icon="mdi:trash-can-outline" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="mt-auto border-t border-gray-100 dark:border-[#383838] px-5 py-3 bg-gray-50/30 dark:bg-[#1A1D21]/30 flex items-center justify-between shrink-0">
                                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-[#ABABAD]">
                                    <span>Linhas por página</span>
                                    <Select
                                        value={String(rowsPerPage)}
                                        onValueChange={(value) => {
                                            setRowsPerPage(Number(value));
                                            setPage(0);
                                        }}
                                    >
                                        <SelectTrigger className="h-7 w-[60px] text-xs">
                                            <SelectValue placeholder={rowsPerPage} />
                                        </SelectTrigger>
                                        <SelectContent side="top">
                                            <SelectItem value="10">10</SelectItem>
                                            <SelectItem value="25">25</SelectItem>
                                            <SelectItem value="50">50</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>

                                <div className="flex items-center gap-2">
                                    <span className="text-xs text-gray-500 dark:text-[#ABABAD]">
                                        {filteredUsers.length > 0 ? page * rowsPerPage + 1 : 0}–{Math.min((page + 1) * rowsPerPage, filteredUsers.length)} de {filteredUsers.length}
                                    </span>
                                    <div className="flex items-center gap-1">
                                        <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 w-7 p-0"
                                            onClick={() => handleChangePage(Math.max(0, page - 1))}
                                            disabled={page === 0}
                                        >
                                            <Iconify icon="mdi:chevron-left" width={16} />
                                        </Button>
                                        <span className="text-xs text-gray-500 dark:text-[#ABABAD] px-1">
                                            {page + 1} / {Math.max(1, Math.ceil(filteredUsers.length / rowsPerPage))}
                                        </span>
                                        <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 w-7 p-0"
                                            onClick={() => handleChangePage(page + 1)}
                                            disabled={(page + 1) * rowsPerPage >= filteredUsers.length}
                                        >
                                            <Iconify icon="mdi:chevron-right" width={16} />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </div>
    );
}